export type RelationShip =
  | 'father'
  | 'mother'
  | 'grandfather'
  | 'grandmother'
  | 'uncle'
  | 'aunt'
  | 'other';

export function validateRelationShip(input: string): RelationShip {
  if (
    input === 'father' ||
    input === 'mother' ||
    input === 'grandfather' ||
    input === 'grandmother' ||
    input === 'uncle' ||
    input === 'aunt' ||
    input === 'other'
  ) {
    return input;
  }

  return 'other';
}

// TODO: schoolマスタを作成する予定
export const schools = [{ id: 1, name: '糸島小学校' }];
export const schoolGrades = ['1年', '2年', '3年', '4年', '5年', '6年'];

export const otherFacilityCities = ['糸島市', '福岡市'];

export const supportTypes = [
  { value: 'after_school_day_service', label: '放課後等デイサービス' },
  { value: 'child_development_support', label: '児童発達支援' },
];

export function getSupportTypes(supportType: string): string {
  const supportTypeList = supportTypes.find((type) => type.value === supportType);
  return supportTypeList ? supportTypeList.label : '';
}

export const supportDays = Array.from({ length: 31 }, (_, i) => (i + 1).toString());
export const maxMonthlyBurdenAmounts = ['0', '4000', '4600', '9300', '37200'];
